module.exports = __webpack_public_path__ + "static/media/emo4a.65df5f3d.png";